<template>
  <div style="padding:10px">
    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height">
      <el-row :gutter="20" style="padding: 10px 0;">
          <el-col :span="colSpan*4/6">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.IRActive') }}</span>：<span style="font-weight:bolder;color: darkslateblue">{{ dataInfo.summary.activeClientQty || 0 }}</span></div>
          </el-col>
          <el-col :span="colSpan*4/6">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.IRLeave') }}</span>：<span style="font-weight:bolder;color: darkslateblue">{{ dataInfo.summary.leaveClientQty || 0 }}</span></div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="padding: 10px 0;">
          <el-col :span="colSpan*4/6">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.IRNew') }}</span>：<span style="font-weight:bolder;color: darkslateblue">{{ dataInfo.summary.newClientQty || 0 }}</span></div>
          </el-col>
        </el-row>
    </el-form>

    <!-- 表头排序表格 -->
    <vxe-table border :data="dataInfo.clientInfos" style="margin:20px -10px 10px;" :empty-text="$t('table.emptyText')"
      :sort-config="{defaultSort: defaultSort}"
      @sort-change="sortChangeEvent">
      <vxe-column field="clientCode" :title="$t('billingPage.IRClientCode')" sortable></vxe-column>
      <vxe-column field="companyName" :title="$t('billingPage.companyName')" sortable></vxe-column>
      <vxe-column field="effectiveDate" :title="$t('billingPage.effectiveDate')" sortable></vxe-column>
      <vxe-column field="startDate" :title="$t('form.startDateText')" sortable></vxe-column>
    </vxe-table>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height">
        <el-row :gutter="20" style="padding: 0 10px;">
          <el-col :span="8">
              <LineChart :chart-data="lineChartDataLine1" height="350px" />
          </el-col>
          <el-col :span="8">
              <LineChart :chart-data="lineChartDataLine2" height="350px" />
          </el-col>
          <el-col :span="8">
              <LineChart :chart-data="lineChartDataLine3" height="350px" />
          </el-col>
        </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height" style="padding-top:50px;">
      <div style="padding-bottom: 20px;"><b>{{ $t('billingPage.IRTPMM') }}</b></div>
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataBar1" />
        </el-col>
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataPie1" />
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>
<script>
import LineChart from '../echartsForm/LineChart';
import { billApi } from '@/api';

export default {
name: 'BillingPageInvoiceReportTotal',
components: { LineChart },
props: {
    chartData: {
      type: Object,
      default: null,
    }
},
data() {
  return {
    colSpan: 6,
    dataInfo: {
      summary: {}
    },
    lineChartDataLine1: {},
    lineChartDataLine2: {},
    lineChartDataLine3: {},
    lineChartDataLine4: {},
    lineChartDataBar1: {},
    lineChartDataPie1: {},
    defaultSort: [{ 'field': 'clientCode', 'order': 'desc' }],
  };
},
methods: {
  sortChangeEvent (column) {
    this.defaultSort = [{ field: column.field, order: column.order }];
    this.$emit('sortChange', column);
  },
  init(params) {
    billApi.getInvoiceReportClientQty(params).then(res => {
      res.data.data.summary = res.data.data.summary || {};
      this.dataInfo = res.data.data;
      const lineChartDataLine1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine1.xAxis.data = res.data.data.weeklyTotalActiveClient?.map(item => item.itemName);
      lineChartDataLine1.series[0].data = res.data.data.weeklyTotalActiveClient?.map(item => item.itemValue);
      lineChartDataLine1.series[0].name = this.$t('billingPage.IRWTAC');
      this.lineChartDataLine1 = lineChartDataLine1;

      const lineChartDataLine2 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine2.xAxis.data = res.data.data.weeklyTotalNewClient?.map(item => item.itemName);
      lineChartDataLine2.series[0].data = res.data.data.weeklyTotalNewClient?.map(item => item.itemValue);
      lineChartDataLine2.series[0].name = this.$t('billingPage.IRWTNC');
      this.lineChartDataLine2 = lineChartDataLine2;

      const lineChartDataLine3 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine3.xAxis.data = res.data.data.weeklyTotalLeaveClient?.map(item => item.itemName);
      lineChartDataLine3.series[0].data = res.data.data.weeklyTotalLeaveClient?.map(item => item.itemValue);
      lineChartDataLine3.series[0].name = this.$t('billingPage.IRWTLC');
      this.lineChartDataLine3 = lineChartDataLine3;

      // 柱状图
      const lineChartDataBar1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataBar));
      lineChartDataBar1.xAxis = {
        data: res.data.data.clientTypeItems?.map(item => item.itemName),
        axisLabel: {
          interval: 0, rotate: 30,
          formatter: function (value, index) {
              var item = res.data.data.clientTypeItems[index];
              return value + '\n' + item.itemValue; // 返回数据名 + 换行的数据值
          }
        }
      };
      lineChartDataBar1.series[0].data = res.data.data.clientTypeItems?.map(item => item.itemValue);
      this.lineChartDataBar1 = lineChartDataBar1;

      // 饼图
      const lineChartDataPie1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataPie));
      lineChartDataPie1.series[0].data = res.data.data.clientTypeItems?.map(item => {
        return { value: item.itemValue, name: item.itemName };
      });
      this.lineChartDataPie1 = lineChartDataPie1;
    });
  }
}
};
</script>
